export enum IncomingCashOperationTypeEnum {
  customerPayment = 0,
  receivingFromBank = 1,
  transferFromAnotherCashAccount = 2,
  withdrowalFromCashRegister = 3,
  loanRepaymentByCounterparty = 4,
  loanRepaymentByEmployee = 5,
  currencyConversion = 6,
  otherPayment = 7,
  vendorRefund = 8,
  returnFromAdvanceHolder = 9,
  paymentFromAnotherCompany = 10,
  loanRepayment = 11,
  otherCompanyRefund = 12,
  lessorRefund = 13,
}
